import FormControlLabel from './FormControlLabel';

// export types
export type { FormControlLabelProps } from './FormControlLabel';

// export components
export { FormControlLabel };
export default FormControlLabel;
